import React, { useState, useEffect } from 'react';
import api from '../api';

const VideoViewer = ({ fileName, className = '', loop = true, autoPlay = true, muted = true, controls = false }) => {
  const [videoUrl, setVideoUrl] = useState('');

  useEffect(() => {
    if (!fileName) return;

    api.get('api/solo/get_homepage_video_url/', {
      params: {
        file_Name: fileName,
      },
    })
      .then((response) => {
        setVideoUrl(response.data.url);
      })
      .catch((error) => console.error('Error fetching video URL:', error));
  }, [fileName]);

  return (
    <div className={`video-container ${className || ''}`}>
      {videoUrl ? (
        <video
          src={videoUrl}
          className="w-full h-auto object-cover rounded-xl"
          autoPlay={autoPlay}
          loop={loop}
          muted={muted}
          controls={controls}
          playsInline
        />
      ) : (
        <div className="flex items-center justify-center p-8 bg-gray-100 dark:bg-gray-800 rounded-xl">
          <p className="text-gray-500 animate-pulse">Loading Video...</p>
        </div>
      )}
    </div>
  );
};

export default VideoViewer;
